const prefix = process.env.VUE_APP_API_URL

export const getWebsiteResourceTypeListAPI = prefix + 'resource/list-by-type/'
export const getWebsiteResourceSingleAPI = prefix + 'resource/resource-by-id/'
export const getWebsiteResourceByTypeAPI = prefix + 'resource/resource-by-type/'
export const getHeaderResourceByTypeAPI = prefix + 'resource/resource-header/'

export const getWebsiteResourceListAPI = prefix + 'resource/type-list/'

export const getWebsiteTextAPI = prefix + 'resource/text-by-type/'

export const getNewsDetail = prefix + 'news/by-id/'
export const getFewNews = prefix + 'news/get-few'
export const getFullNews = prefix + 'news/get-full'

export const getVendorList = prefix + 'vendor/list-vendor-names'
